module.exports = __webpack_public_path__ + "static/ISR-Investigator-Qualification-Form-7af562744096dde97cc831887b3d8441.pdf";